<template>
  <div class="qq">
    <img src="@/assets/imgs/qq.png" alt="">
  </div>
</template>
<script>
export default {
  name:'qq',
  data(){
    return{

    }
  },
}
</script>

<style lang="less" scoped>
  .qq{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: .1rem;
    img{
      width: .66rem;
      height: .67rem;
      margin: 0 auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/qq.vue